// eslint-disable-next-line import/no-named-as-default
import { api } from './base.service';

export const getAllDailySchedulesByMonth = (params) => {
  const { year, month } = params;
  return api().get(`/api/daily-schedules/${year}/${month}`);
};

export const getDailyScheduleContent = (params) => {
  const { year, month, day, version } = params;
  return api().get(`/api/daily-schedules/web/${year}/${month}/${day}/${version}/content`);
};

export const saveChanges = (params) => {
  const { dailyScheduleId, changes } = params;
  return api().put(`/api/daily-schedules/${dailyScheduleId}`, { changes });
};

export const saveChangesAsNewVersion = (params) => {
  const { dailyScheduleId, changes } = params;
  return api().post(`/api/daily-schedules/${dailyScheduleId}/version`, { changes });
};

export const sendScheduleToReview = (params) => {
  const { scheduleId } = params;
  return api().patch(`/api/daily-schedules/${scheduleId}/submit`);
};

export const approveDailySchedule = (params) => {
  const { scheduleId } = params;
  return api().patch(`/api/daily-schedules/${scheduleId}/approve`);
};

export const rejectDailySchedule = (params) => {
  const { scheduleId } = params;
  return api().patch(`/api/daily-schedules/${scheduleId}/reject`);
};

export const generateDailySchedule = (params) => {
  const { year, month, day } = params;
  const payload = {
   year,
   monthNumber: month,
   day
  }
  return api().post('/api/daily-schedules/generate', payload);
}
